<div class="dark-button dark-button--{{ type }}">
    <ng-content></ng-content>
</div>
